import * as types from '../actionTypes';

export const pettyCashierGetTwoNumbersRequest = data => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_REQUEST,
    payLoad: data
  };
};

export const pettyCashierGetTwoNumbersSuccess = data => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_SUCCESS,
    payLoad: data
  };
};
export const pettyCashierGetTwoNumbersFailure = (data) => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_FAILURE
  };
};


export const pettyCashierGetCashRemainRequest = data => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_REQUEST,
  };
};

export const pettyCashierGetCashRemainSuccess = data => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_SUCCESS,
    payLoad: data
  };
};
export const pettyCashierGetCashRemainFailure = (data) => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_FAILURE
  };
};


export const pettyCashierGetClassificationRequest = () => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_REQUEST,
  };
};

export const pettyCashierGetClassificationSuccess = data => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_SUCCESS,
    payLoad: data
  };
};
export const pettyCashierGetClassificationFailure = (data) => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_FAILURE
  };
};


export const pettyCashierGetPaymentRequest = data => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_PAYMENT_REQUEST,
  };
};

export const pettyCashierGetPaymentSuccess = data => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_PAYMENT_SUCCESS,
    payLoad: data
  };
};
export const pettyCashierGetPaymentFailure = (data) => {
  return {
    type: types.PETTY_CASHIER_DASHBOARD_GET_PAYMENT_FAILURE
  };
};